<template>
  <div class="main">
    <report-top v-if="!scan">
      <ly-search slot="search" v-model="searchItem.keyword" @search="getList"></ly-search>
    </report-top>
    <selectTool ref="selectTool">
      <template slot="text">位置标注点列表</template>
      <template slot="btn"><Button @click="getList" type="error" class="chaxun">查询</Button><Button @click="openAdd"
          type="primary" class="chaxun">新增</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)" @on-selection-change="selectData = $event">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <Button v-if="checkMore" @click="$emit('objs', selectData)" type="success">我选好了</Button>
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>

    <form-model 
    @close="close" width="1200" 
    ref="formModel" 
    :title="isAdd ? '新增标注点' : '编辑标注点'"
    :overAuto="true" 
    fullscreen>
      <div style="width: 100%; height: calc(100% - 100px); margin-bottom: 10px" slot="topcontent">
        <point ref="point"></point>
      </div>
      <Input slot="address" v-model="item.address">
      <template #suffix>
        <Button @click="autoGetAddress">自动获取</Button>
      </template>
      </Input>
      <Button slot="btn" type="primary" @click="addUpdate">确认修改</Button>
    </form-model>
    <blind ref="blind"></blind>
  </div>
</template>
<script>
import point from "../map/point.vue";
import point20 from "../map20/point.vue";
var vmap = localStorage.getItem('vmap');
export default {
  props: ["scan", "checkMore", "outUse"],
  components: { point:vmap==2.0?point20:point },
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
          noTable: this.checkMore != true,
        },

        {
          title: "创建者账号",
          key: "createAccount",
          sort: 20,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          sort: 20,
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
          sort: 20,
        },
      ],
      tableData: [],
      item: {
        cs: 2,
        name: "",
        radius: 100,
        x: 0,
        y: 0,
        remark: "",
        type: "",
        address: "",
      },
      forms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
          span: 4,
          sort: 2,
        },
        {
          title: "半径/米",
          key: "radius",
          type: "Select",
          selectItems: [20, 50, 100, 200, 300, 500, 1000],
          required: true,
          span: 4,
          sort: 2,
        },
        {
          title: "标注类型",
          key: "type",
          type: "Select",
          selectItems: ["学校", "公司", "医院", "工厂"],
          required: false,
          span: 4,
          sort: 2,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          required: false,
          span: 4,
          sort: 2,
        },
        {
          title: "详细地址",
          key: "address",
          slotForm: "address",
          required: false,
          span: 7,
          sort: 2,
        },
      ],
      searchItem: { pageNumber: 1, pageSize: 50, keyword: "" },

      total: 0,
      selectData: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/marker/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      var ccc = this.$refs.point.getPoint();
      //this.item.address = ccc.address;
      this.item.x = ccc.x;
      this.item.y = ccc.y;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.rule + "/marker/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();

            if (this.outUse) {
              this.$emit("ok");
            } else {
              this.getList();
            }
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.rule + "/marker/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            if (this.outUse) {
              this.$emit("ok");
            } else {
              this.getList();
            }
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.rule + "/marker/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              if (this.outUse) {
                this.$emit("ok");
              } else {
                this.getList();
              }
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
      setTimeout(() => {
        this.$refs.point.drawMap(row);
      }, 200);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
      setTimeout(() => {
        this.$refs.point.drawMap();
      }, 200);
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    drawCir(v) {
      this.$refs.point.drawCir(v);
    },
    autoGetAddress() {
      var ccc = this.$refs.point.getPoint();
      var pointList = [
        {
          x: ccc.x,
          y: ccc.y,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.item.address =
          data[0].address == null ? "暂无地址" : data[0].address;
      });
    },
    close() {
      this.$refs.point.destroyMap();
    },
  
  },
  mounted() {
    this.columns = this.utils.cols(this.forms, this.columns);
    this.getList();
  },
  computed: {
    radius() {
      return this.item.radius;
    },
  },
  watch: {
    radius(v) {
      setTimeout(() => {
        this.drawCir(v);
      }, 500);

    },
  },
};
</script>
<style>
#sderwwetcsd {
  position: absolute;
  width: 240px;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/rule/rulePoint.vue